var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg4 = function Svg4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(-98 -50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 16,
    height: 16,
    transform: "translate(98 50)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_4-2",
    "data-name": 4,
    transform: "translate(100 52.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M8.065,3.49a.241.241,0,0,1-.085-.016.237.237,0,0,1-.135-.306,2.068,2.068,0,0,1,.542-.841.236.236,0,0,1,.3.365,1.7,1.7,0,0,0-.4.647.237.237,0,0,1-.22.151",
    transform: "translate(-4.371 -1.269)",
    fill: "#ffb229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M17.912,3.49a.237.237,0,0,1-.22-.151,1.7,1.7,0,0,0-.4-.647.236.236,0,0,1,.3-.365,2.068,2.068,0,0,1,.542.841A.237.237,0,0,1,18,3.474a.241.241,0,0,1-.085.016",
    transform: "translate(-9.606 -1.27)",
    fill: "#ffb229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M11.1,15.235H2.242A1.04,1.04,0,0,1,1.2,14.2V9.614a1.039,1.039,0,0,1,1.04-1.039H11.1a1.039,1.039,0,0,1,1.04,1.039V14.2a1.04,1.04,0,0,1-1.04,1.04",
    transform: "translate(-0.671 -4.788)",
    fill: "#8c685c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M1.2,6.618V9.635c.011,0,.022.011.034.015l1.391.5a12.046,12.046,0,0,0,8.087,0l1.391-.5c.012,0,.023-.01.034-.015V6.618a1.04,1.04,0,0,0-1.04-1.04H2.242A1.04,1.04,0,0,0,1.2,6.618",
    transform: "translate(-0.671 -3.114)",
    fill: "#725047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M11.435,8.564l-1.391.5a12.048,12.048,0,0,1-8.088,0l-1.391-.5A.85.85,0,0,1,0,7.762V5.532a1.04,1.04,0,0,1,1.04-1.04h9.921A1.04,1.04,0,0,1,12,5.532V7.762a.851.851,0,0,1-.565.8",
    transform: "translate(0 -2.508)",
    fill: "#997368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M13.047,14.11H11.69a.283.283,0,0,0-.283.284v.9H13.33v-.9a.283.283,0,0,0-.284-.284",
    transform: "translate(-6.369 -7.878)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M13.116,17.566h-.836A.283.283,0,0,1,12,17.283v-.491h1.4v.491a.283.283,0,0,1-.283.283",
    transform: "translate(-6.699 -9.375)",
    fill: "#ffb229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M9.614,1.455a.52.52,0,0,1-.306-.94A3.069,3.069,0,0,1,11.077,0a3.069,3.069,0,0,1,1.769.515.52.52,0,1,1-.611.841,2.047,2.047,0,0,0-1.158-.316,2.046,2.046,0,0,0-1.158.316.517.517,0,0,1-.305.1",
    transform: "translate(-5.077 0)",
    fill: "#8c685c"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4.5a156bab.svg";
export { ForwardRef as ReactComponent };